import { AbstractFormElement, ICustomFormElement } from "./Abstract";
import LoaderOverlay from "../../Modules/LoaderOverlay";
import { HTTPError } from "../../Exceptions/HTTPError";

const VAT_ID_ENDPOINT = `${Shopify.routes.root}apps/vat/api/submit-vat-validate`;

class Vat extends AbstractFormElement implements ICustomFormElement {
    protected mainEvent = "blur";

    static validateVATNumber = async (vat_number: string) => {
        const response = await fetch(VAT_ID_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ vat_number })
        });
        if (response.status !== 200) throw new HTTPError(response.status, response.statusText);
        return await response.json();
    };

    attachEvents() {
        this.input.addEventListener("focus", () => this.label.classList.add("validates"));
        this.internals.form?.addEventListener("submit", this.submitListener);
        this.input.addEventListener(this.mainEvent, (e) => {
            this.validate();
            this.dispatchEvent(new Event(this.mainEvent, e));
            this.internals.form?.dispatchEvent(new CustomEvent("formchange", { detail: this }));
            this.label.classList.toggle("has-value", this.value !== "");
            // @ts-ignore
            this.internals.states[this.value !== "" ? "add" : "delete"]("--has-value");
        });
        this.label.addEventListener("click", this.clickHandler);
        return this;
    }

    validate(): boolean {
        if (this.input.validity.valueMissing) return super.validate();
        const loader = new LoaderOverlay(this.internals.form).render();
        Vat.validateVATNumber(this.input.value)
            .then(/* ignore */)
            .catch(() => {
                this.input.setCustomValidity("custom-error");
                super.validate();
            })
            .finally(() => {
                loader.destroy();
            });
        return super.validate();
    }
}

Vat.prototype.template = document.createElement("template");

Vat.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-vat", Vat);

export { Vat };
